"use client";

import { ErrorContent } from "./_components/ErrorContent";

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ErrorPage({ reset }: Props) {
  return <ErrorContent reset={reset} />;
}
